import React from 'react';
import { connect } from 'react-redux';
import { Button, Header, Modal } from 'semantic-ui-react';
import { hidePromoAnalysisDetailsModal } from '../../redux/actions/modals';
import DataGrid from '../shared/DataGrid';

class PromoAnalysisDetailsModal extends React.Component {
  
  onClose = () => this.props.hidePromoAnalysisDetailsModal();

  render() {

    const { grid, open } = this.props.modal;

    return (
        <Modal
            open={open}
            onClose={this.onClose}
            size='large'
            closeIcon
        >
          <Modal.Header>
            <Header size="tiny">
              Promo Analysis
              <Header.Subheader>[Site Name], [Town] - [Collection Week & Range]</Header.Subheader>
            </Header>
          </Modal.Header>
          <Modal.Content style={{ minHeight: "400px"}} className="gs-flex-container-vertical">
            <DataGrid
              headings={grid.headerDef}
              data={grid.data}
              rowDef={grid.rowDef}
              hideOverflow
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.promoAnalysisDetailsModal,
  };
};

export default connect(mapStateToProps, { hidePromoAnalysisDetailsModal })(PromoAnalysisDetailsModal);


